import Button from '@/components/atoms/button';
import Heading from '@/components/atoms/heading';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

import IconCrossCircle from '~/svg/IconCrossCircle.svg';

type ContactSalesFormSuccessProps = {
  onSubmit: () => void;
};

export function ContactSalesFormError({
  onSubmit,
}: ContactSalesFormSuccessProps) {
  const { texts } = useTranslation();

  return (
    <div className='flex min-h-[650px] flex-col items-center justify-start'>
      <div className='text-neutral-N99 mb-12'>
        {currentLocaleConfig().logo()}
      </div>
      <div className='mb-6 flex items-center gap-3'>
        <IconCrossCircle className='text-error-E99 max-h-7 min-h-7 min-w-7 max-w-7' />
        <Heading level='h2'>
          {texts.contact_sales.error.something_went_wrong}
        </Heading>
      </div>
      <p className='mb-9'>{texts.contact_sales.error.error_please_try_again}</p>
      <Button onClick={onSubmit} classNames={{ root: 'md:w-auto w-full' }}>
        {texts.contact_sales.error.try_again}
      </Button>
    </div>
  );
}
